<template>
  <section class="qrs-typography">
    <pageHeader>
      <h1 class="qrs-header-xl">Share</h1>
    </pageHeader>
    <backButton :goBack="goBack" />

    <p>
      You can email your <strong>"Getting to know me"</strong> information to people who can help
      you to stay well.
    </p>

    <p>For example - a family member, a carer, a healthcare professional.</p>

    <p>You will need to know their email address.</p>

    <button
      name="Share via email"
      aria-label="Share my information via email"
      class="govuk-button govuk-button--secondary mt--24"
      @click="$parent.goTo($ShareForm)"
    >
      Share via email
      <span class="screen-reader-text">Share my information via email</span>
    </button>
  </section>
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$parent.goTo(this.$MainLanding);
    },
  },
};
</script>